import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="57" viewBox="0 0 66 57" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1_2)">
      <path d="M43.6615 0H66V57.6746H43.6615V0Z" fill="#EF3340" />
      <path d="M22.3385 0H43.6615V57.6746H22.3385V0Z" fill="#FDDA25" />
      <path d="M0 0H22.3385V57.6746H0V0Z" fill="black" />
      <path d="M66 0H0V57H66V0Z" stroke="#9F9D9D" />
    </g>
    <defs>
      <clipPath id="clip0_1_2">
        <rect width="66" height="57" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
